var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStateIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Component 13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3995_64923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip4_225_74449"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 0.490234H0V16.4902H16V0.490234Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3995_64923)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.3757 2.9065C10.5471 2.99991 10.6539 3.17958 10.6539 3.37488V13.2883C10.6539 13.693 10.2209 13.9503 9.8654 13.7567L5.57506 11.42C5.4035 11.3266 5.29688 11.1469 5.29688 10.9516V1.03799C5.29688 0.633293 5.72986 0.376052 6.08535 0.569632L10.3757 2.9065Z",
    fill: "#E85F3D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.33042 12.8626L0.800852 15.5421C0.623213 15.6472 0.398438 15.5193 0.398438 15.3127V5.10846C0.398438 4.82568 0.547801 4.56392 0.791007 4.41994L5.33042 1.73438L10.7254 4.65224L15.1588 1.97827C15.3366 1.87108 15.5633 1.99907 15.5633 2.20663V12.4109C15.5633 12.6912 15.4164 12.9512 15.1764 13.096L10.7254 15.7803L5.33042 12.8626Z",
    fill: "url(#paint0_radial_3995_64923)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.19657 12.7855L0.732342 15.4265C0.643523 15.479 0.53125 15.4149 0.53125 15.3117V5.10741C0.53125 4.87177 0.655474 4.65364 0.858459 4.53365L5.19657 1.96713V12.7855ZM5.46324 12.7821V1.95703L10.5915 4.73067V15.5555L5.46324 12.7821ZM10.8582 15.5431V4.72648L15.2271 2.09141C15.3159 2.03781 15.4292 2.1018 15.4292 2.20558V12.4098C15.4292 12.6435 15.3069 12.8601 15.1068 12.9808L10.8582 15.5431Z",
    stroke: "url(#paint1_linear_3995_64923)",
    strokeWidth: 1.273,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.5625 8.08984L9.42965 9.42396",
    stroke: "white",
    strokeWidth: 0.82,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3995_64923",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.18771 7.82424) rotate(-16.6517) scale(17.7112 32.2096)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB512D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#EC7453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.749777,
    stopColor: "#FF7B55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E85F3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3995_64923",
    x1: 1.63751,
    y1: 6.84368,
    x2: 6.69916,
    y2: 16.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.24
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateIcon);
export default __webpack_public_path__ + "static/media/stateIcon.ee6f8d0139e7dbd6596520a1fec01510.svg";
export { ForwardRef as ReactComponent };